import * as React from 'react'
import { Field, useFormikContext } from 'formik'
import { MuiTextFieldFormik } from '@user/components/Formik'
import { ActivityType } from '../../../typings'

const maxLength = 150
const inputProps = { maxLength: maxLength }

export function Description() {
  const { values } = useFormikContext<ActivityType>()
  const helperText = `${values.description?.length ?? 0}/${maxLength}`
  return (
    <Field
      fullWidth
      size="small"
      name="description"
      label="Description"
      margin="normal"
      component={MuiTextFieldFormik}
      inputProps={inputProps}
      helperText={helperText}
    />
  )
}
